var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "mb-2" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("delegationOrder.decision.summary")))])
      ]),
      _c(
        "div",
        [
          _c("strong", [
            _vm._v(_vm._s(_vm.$t("delegationOrder.decision.status")) + ":")
          ]),
          _c("delegation-order-status-chip", {
            attrs: { status: _vm.delegationDecision.status }
          })
        ],
        1
      ),
      _vm.$store.state.Auth.userProperties == null ||
      _vm.$store.state.Auth.userProperties.system_settings
        .cost_centre_on_delegations !== 3
        ? _c("div", [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.$t("delegationOrder.decision.costCentre")) + ": "
              )
            ]),
            _vm._v(
              " " +
                _vm._s(
                  _vm.delegationDecision.cost_centre == null
                    ? _vm.$t("global.notSet")
                    : _vm.delegationDecision.cost_centre.name
                ) +
                " "
            )
          ])
        : _vm._e(),
      _c("div", [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("delegationOrder.decision.delegated")) + ": ")
        ]),
        _vm._v(
          _vm._s(_vm.delegationDecision.user_name) +
            " (" +
            _vm._s(_vm.delegationDecision.user_login) +
            ") "
        )
      ]),
      _c("div", [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("delegationOrder.decision.destination")) + ":")
        ]),
        _vm._v(" " + _vm._s(_vm.delegationDecision.destinationText) + " ")
      ]),
      _c("div", [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("delegationOrder.decision.task")) + ":")
        ]),
        _vm._v(
          " " +
            _vm._s(
              _vm.$i18n.locale === "pl" ||
                _vm.delegationDecision.task_name_en == null
                ? _vm.delegationDecision.task_name
                : _vm.delegationDecision.task_name_en
            ) +
            " "
        )
      ]),
      _vm.delegationDecision.task != null &&
      _vm.delegationDecision.task.length > 0
        ? _c("div", [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.$t("delegationOrder.decision.taskDescription")) + ":"
              )
            ]),
            _vm._v(" " + _vm._s(_vm.delegationDecision.task) + " ")
          ])
        : _vm._e(),
      _c("div", [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("delegationOrder.decision.startDate")) + ":")
        ]),
        _vm._v(
          " " + _vm._s(_vm.formatDate(_vm.delegationDecision.start_date)) + " "
        )
      ]),
      _c("div", [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("delegationOrder.decision.endDate")) + ":")
        ]),
        _vm._v(
          " " + _vm._s(_vm.formatDate(_vm.delegationDecision.end_date)) + " "
        )
      ]),
      _vm.delegationDecision.external_customer_name != null &&
      _vm.delegationDecision.external_customer_name.length > 0
        ? _c("div", [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.$t("delegation.form.fields.externalCustomer.name")) +
                  ":"
              )
            ]),
            _vm._v(
              " " + _vm._s(_vm.delegationDecision.external_customer_name) + " "
            )
          ])
        : _vm._e(),
      _vm.delegationDecision.project_name != null &&
      _vm.delegationDecision.project_name.length > 0
        ? _c("div", [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.$t("delegation.form.fields.project.name")) + ":"
              )
            ]),
            _vm._v(" " + _vm._s(_vm.delegationDecision.project_name) + " ")
          ])
        : _vm._e(),
      _c("delegation-order-restrictions", {
        attrs: {
          "allowed-transport-cost-model":
            _vm.delegationDecision.allowed_transport_cost,
          "allowed-transport-model": _vm.delegationDecision.allowed_transport
        },
        on: {
          "update:allowedTransportCostModel": function($event) {
            return _vm.$set(
              _vm.delegationDecision,
              "allowed_transport_cost",
              $event
            )
          },
          "update:allowed-transport-cost-model": function($event) {
            return _vm.$set(
              _vm.delegationDecision,
              "allowed_transport_cost",
              $event
            )
          },
          "update:allowedTransportModel": function($event) {
            return _vm.$set(_vm.delegationDecision, "allowed_transport", $event)
          },
          "update:allowed-transport-model": function($event) {
            return _vm.$set(_vm.delegationDecision, "allowed_transport", $event)
          }
        }
      }),
      _c("collapse-simple-advance-panel", {
        attrs: {
          "model-advances": _vm.delegationDecision.advances,
          addable: false
        },
        on: {
          "update:modelAdvances": function($event) {
            return _vm.$set(_vm.delegationDecision, "advances", $event)
          },
          "update:model-advances": function($event) {
            return _vm.$set(_vm.delegationDecision, "advances", $event)
          }
        }
      }),
      _c(
        "v-btn",
        {
          staticClass: "primary ma-3",
          attrs: { disabled: _vm.$store.getters["Ajax/loading"] },
          on: { click: _vm.downloadSettlement }
        },
        [_vm._v(_vm._s(_vm.$t("delegationOrder.decision.downloadStatement")))]
      ),
      _c(
        "v-btn",
        {
          staticClass: "primary",
          attrs: {
            to: "/delegation-order/readonly/" + _vm.delegationDecision.id
          }
        },
        [_vm._v(_vm._s(_vm.$t("delegationOrder.viewReadonly")))]
      ),
      _c("h2", [
        _vm._v(_vm._s(_vm.$t("delegationOrder.decision.acceptanceHistory")))
      ]),
      _c("div", [
        _vm._v(
          " " +
            _vm._s(_vm.$t("delegationOrder.decision.created")) +
            " " +
            _vm._s(_vm.$t("global.at")) +
            " " +
            _vm._s(_vm.delegationDecision.created_at) +
            " " +
            _vm._s(_vm.$t("global.by")) +
            " " +
            _vm._s(_vm.delegationDecision.created_by_name) +
            " (" +
            _vm._s(_vm.delegationDecision.created_by_login) +
            "). "
        )
      ]),
      _vm._l(_vm.delegationDecision.history, function(historyItem) {
        return _c("span", [_vm._v(_vm._s(historyItem) + " "), _c("br")])
      }),
      _vm.delegationDecision.hasPermissionForSubstantialDecision &&
      _vm.delegationDecision.status === 2
        ? _c(
            "div",
            [
              _c("h2", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "delegationOrder.decision.hasPermissionForSubstantialDecision"
                      )
                    ) +
                    " "
                )
              ]),
              _c(
                "v-row",
                { staticClass: "text-center" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    {
                      staticClass: "choose-box elevation-5  vertical-align",
                      attrs: { md: "4", cols: "12" }
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("delegationOrder.decision.positive.title")
                          )
                        )
                      ]),
                      _c("v-icon", { attrs: { size: "75px" } }, [
                        _vm._v("fa-check")
                      ]),
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.delegationDecision.accepted_by_id == null
                                ? _vm.$t(
                                    "delegationOrder.decision.positive.description.substantial"
                                  )
                                : _vm.$t(
                                    "delegationOrder.decision.positive.description.substantialAlready"
                                  )
                            ) +
                            " "
                        )
                      ]),
                      _c("br"),
                      _c("br"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: _vm.$store.getters["Ajax/loading"],
                            bottom: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.accept()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "delegationOrder.decision.positive.acceptButton"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    {
                      staticClass: "choose-box elevation-5",
                      attrs: { md: "4", cols: "12" }
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("delegationOrder.decision.negative.title")
                          )
                        )
                      ]),
                      _c("v-icon", { attrs: { size: "75px" } }, [
                        _vm._v("fa-ban")
                      ]),
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "delegationOrder.decision.negative.description.substantial"
                              )
                            ) +
                            " "
                        )
                      ]),
                      _c("br"),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-3",
                          attrs: {
                            disabled: _vm.$store.getters["Ajax/loading"],
                            bottom: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.deny()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "delegationOrder.decision.negative.denyButton"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-3",
                          attrs: {
                            disabled: _vm.$store.getters["Ajax/loading"],
                            bottom: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.denyAndRevert()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "delegationOrder.decision.negative.denyAndRevertButton"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }